/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConUserBrandWebControllerV1ListUsingGet1Params,
  ResultConUserAuthBrandWebV1ListPresponse,
  ResultTotalListResponseConUserBrandWebV1ListResponse,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class ConUserBrandWebController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags con-user-brand-web-controller
   * @name ConUserBrandWebControllerV1ListUsingGet1
   * @summary 我的品牌库
   * @request GET:/consumebrand/web/v1/conuserbrand
   * @secure
   */
  conUserBrandWebControllerV1ListUsingGet1 = (
    query: ConUserBrandWebControllerV1ListUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultTotalListResponseConUserBrandWebV1ListResponse, void>({
      path: `/consumebrand/web/v1/conuserbrand`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-user-brand-web-controller
   * @name ConUserBrandWebControllerV1UserAuthBrandUsingGet1
   * @summary 查询用户认证的品牌信息
   * @request GET:/consumebrand/web/v1/userauthbrand
   * @secure
   */
  conUserBrandWebControllerV1UserAuthBrandUsingGet1 = (params: RequestParams = {}) =>
    this.request<ResultConUserAuthBrandWebV1ListPresponse, void>({
      path: `/consumebrand/web/v1/userauthbrand`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
